import { ReactComponent as InfoIcon } from 'assets/icons/info-primary.svg';

import * as Styled from './ReportErrorAlert.styles';
import { ReportErrorAlertProps } from './ReportErrorAlert.types';

export const ReportErrorAlert = ({ message }: ReportErrorAlertProps) => {
  return (
    <Styled.AlertContainer>
      <Styled.IconWrapper>
        <InfoIcon />
      </Styled.IconWrapper>
      <Styled.Message>{message}</Styled.Message>
    </Styled.AlertContainer>
  );
};
